// extracted by mini-css-extract-plugin
export default {"pagina_conteudo":"calendarioAlunos_pagina_conteudo__Ip6F7"};